import ExtendedDatagrid from 'ui-component/DataGrid/ExtendedDatagrid';
import { DatagridNames } from 'types/datagrid';
import { DecoratedKitRequestLine } from 'hooks/useGetDecoratedKitRequestLines';
import { columns } from 'ui-component/AllocatedPartsDatagrid/columns';
import { KitRequestSubtype } from 'views/kitting/Kit/KitRequestContext';
import { StockLotDetailPanel } from 'ui-component/AllocatedPartsDatagrid/StockLotDetailPanel';

type AllocatedPartsDatagridProps = {
  rows: DecoratedKitRequestLine[];
  loading?: boolean;
  kitRequest?: KitRequestSubtype | null;
};

export const AllocatedPartsDatagrid = ({
  rows,
  loading,
  kitRequest,
}: AllocatedPartsDatagridProps) => (
  <ExtendedDatagrid<DecoratedKitRequestLine>
    gridName={DatagridNames.allocatedParts}
    columns={columns}
    rows={loading ? [] : rows}
    loading={loading}
    toolbarColumns
    toolbarFilters
    toolbarQuickFilter
    toolbarReset
    enableStateQueryParams
    exportFileNamePrefix="AllocatedParts"
    detailPanel
    getDetailPanelContent={({ row }) => (
      <StockLotDetailPanel row={row} kitRequest={kitRequest} />
    )}
  />
);
